export const ACCOUNT_FORM_NAME = 'account';
export const LOGIN_FORM_NAME = 'login';
export const SIGNUP_FORM_NAME = 'signup';
export const NEW_PROJECT_FORM_NAME = 'newProject';
export const LAWYER_SIGNUP_FORM_NAME = 'lawyer_signup';
export const REFERRER_SIGNUP_FORM_NAME = 'referrer_signup';
export const CLIENT_BOOKING_FORM_NAME = 'client_booking';
export const REFERRER_BOOKING_FORM_NAME = 'referrer_booking';
export const CLIENTBOOKINGS_DETAIL_FORM_NAME = 'client_booking_details';
export const CLIENTS_DETAIL_FORM_NAME = 'clients_details';
export const UPLOAD_WILL_FORM_NAME = 'upload_will';
export const RESET_PASSWORD ='reset_password';
